// extracted by mini-css-extract-plugin
export default {"quote":"typography-module--quote--79eb3","source":"QuoteCard-module--source--3d170"};